module.exports = __webpack_public_path__ + "static/media/damjan_gjurovski.85fcbfff.jpeg";